import { useRealmAuthContext } from '@interxfi/api-client';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Logomark, type LogomarkSize } from '@interxfi/design-system/components/logomark/logomark';
import type { TypographyProps } from '@interxfi/design-system/components/typography';
import { Typography } from '@interxfi/design-system/components/typography';
import { ProgramLogomark } from '../userauth/program/logomark/program-logomark';

export interface TenantLogomarkProps {
  hideUntilLoaded?: boolean;
  nameTypography?: TypographyProps;
  overrideSrc?: string;
  size?: LogomarkSize;
  tenantType: string | undefined;
  tenantId: string | undefined;
  withName?: boolean;
  shouldLoadLogoMark?: boolean;
}

export function TenantLogomark({
  hideUntilLoaded,
  nameTypography,
  overrideSrc,
  shouldLoadLogoMark,
  size,
  tenantType,
  tenantId,
  withName,
}: TenantLogomarkProps) {
  const ctx = useRealmAuthContext();
  if (tenantType === 'program') {
    return (
      <ProgramLogomark
        hideUntilLoaded={hideUntilLoaded}
        nameTypography={nameTypography}
        overrideSrc={overrideSrc}
        programId={tenantId}
        shouldLoadLogoMark={shouldLoadLogoMark}
        size={size}
        withLink={false}
        withName={withName}
      />
    );
  }

  if (hideUntilLoaded && !tenantId) {
    return null;
  }

  const match = ctx?.accesses?.find((access) => access.tenant?.tenantId === tenantId);
  const name = match?.tenant?.data?.spec?.name;

  return (
    <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
      <Logomark size={size} tenantName={name} tenantType={tenantType} />

      {withName && name ? (
        <Typography lineHeight="1rem" size="0.875rem" tone="neutral-dk" {...nameTypography}>
          {name}
        </Typography>
      ) : null}
    </HorizontalStack>
  );
}
